import { ProductType } from 'constants/enums/productTypes'
import { PropertyType } from 'constants/enums/propertyTypes'
import { PurposeOfLoan } from 'constants/enums/purposeOfLoanTypes'
import { TranslationFile } from 'i18n'
import { IApplicationInformation } from 'interfaces/i-application-information'
import { useTranslation } from 'react-i18next'
import { checkIsMobile, FormatEnumToList } from 'utils/commonhelpers'

export const ApplicationBankInfoForm = (data: IApplicationInformation) => {
	const { t } = useTranslation()

	return {
		fieldSetName: '',
		formName: 'ApplicationBankInfoForm',
		collapsable: false,
		show: true,
		visible: true,
		market: 'es',
		fullSize: true,
		col: 12,
		controls: [
			{
				required: true,
				controlName: 'ibanVal',
				type: 'text',
				label: t('forms:Iban'),
				description: t('forms:IbanDescription'),
				value: data.bankInfo.iban,
				validations: [
					{
						code: 'MustMatchPattern',
						value: '\\b^(ES)\\s*(\\d{2})\\s*(\\d{4})\\s*(\\d{4})\\s*(\\d{2})\\s*(\\d{10})\\b$',
						message: t('InvalidFormat'),
					},
				],
				visible: true,
				col: 12,
			},
		],
	}
}

export const ApplicationBankInfoFormFi = (data: IApplicationInformation) => {
	const { t } = useTranslation()

	return {
		fieldSetName: '',
		formName: 'ApplicationBankInfoFormFi',
		collapsable: false,
		show: true,
		visible: true,
		market: 'fi',
		fullSize: true,
		col: 12,
		controls: [
			{
				required: true,
				controlName: 'ibanVal',
				type: 'text',
				label: t('forms:Iban'),
				value: data.bankInfo.iban,
				maxLength: 18,
				validations: [
					{
						code: 'MustMatchPattern',
						value: '^(f|F)(i|I)([0-9]{16})$',
						message: t('InvalidIban'),
					},
				],
				visible: true,
				col: 12,
			},
		],
	}
}

export const ApplicationBankInfoFormDk = (data: IApplicationInformation) => {
	const { t } = useTranslation([TranslationFile.Forms])
	const isMobile = checkIsMobile()

	return {
		fieldSetName: '',
		formName: 'ApplicationBankInfoFormDk',
		collapsable: false,
		show: true,
		visible: true,
		market: 'dk',
		fullSize: true,
		col: 12,
		controls: [
			{
				required: true,
				controlName: 'directDebitClearingNumber',
				type: 'text',
				label: t('forms:DirectDebitClearingNumber'),
				value: data.bankInfo?.directDebitClearingNumber,
				visible: true,
				validations: [
					{
						code: 'MustMatchPattern',
						value: '^(\\d{4})?$',
						message: t(
							'forms:ValidationMsgDirectDebitClearingNumber'
						),
					},
				],
				col: isMobile ? 12 : 4,
			},
			{
				required: true,
				controlName: 'directDebitAccount',
				type: 'text',
				label: t('forms:DirectDebitAccountNumber'),
				value: data.bankInfo?.directDebitAccount,
				validations: [
					{
						code: 'MustMatchPattern',
						value: '^(\\d{7,10})?$',
						message: t('forms:ValidationMsgDirectDebitAccount'),
					},
				],
				visible: true,
				col: isMobile ? 12 : 8,
			},
		],
	}
}

export const ApplicationBankInfoFormLt = (data: IApplicationInformation) => {
	const { t } = useTranslation()

	return {
		fieldSetName: '',
		formName: 'ApplicationBankInfoFormLt',
		collapsable: false,
		show: true,
		visible: true,
		market: 'lt',
		fullSize: true,
		description: t('forms:BankInfoFormDescription'),
		col: 12,
		controls: [
			{
				required: true,
				controlName: 'ibanVal',
				type: 'text',
				label: t('forms:Iban'),
				value: data.bankInfo.iban,
				maxLength: 20,
				validations: [
					{
						code: 'MustMatchPattern',
						value: '^(l|L)(t|T)([0-9]{18})$',
						message: t('InvalidIban'),
					},
				],
				visible: true,
				col: 12,
			},
			{
				options: [
					{
						value: false,
						label: t('No'),
					},
					{
						value: true,
						label: t('Yes'),
					},
				],
				required: true,
				controlName: 'beneficialOwner',
				type: 'dropdown',
				label: t('forms:BeneficialOwner'),
				tooltip: t('forms:BeneficialOwnerInfoDescription'),
				value: true,
				visible: true,
				col: 12,
				wcagAriaLabel: t('forms:WCAG-Label_DropDownBoolean'),
			},
			{
				options: [
					{
						value: false,
						label: t('No'),
					},
					{
						value: true,
						label: t('Yes'),
					},
				],
				required: true,
				controlName: 'pep',
				type: 'dropdown',
				label: t('forms:PoliticallyExposedPerson'),
				tooltip: t('forms:PEPInfoDescription'),
				value: false,
				visible: true,
				col: 12,
				wcagAriaLabel: t('forms:WCAG-Label_DropDownBoolean'),
			},
			{
				options: FormatEnumToList(
					PurposeOfLoan,
					PropertyType.PurposeOfLoan,
					TranslationFile.Dropdown
				),
				required: data?.product === ProductType.LtuCashLoan,
				controlName: 'purposeOfLoan',
				type: 'dropdown',
				label: t('forms:ApplicationPurposeOfLoan'),
				value:
					data?.product === ProductType.LtuCashLoan
						? 'Consumption'
						: null,
				visible: data?.product === ProductType.LtuCashLoan,
				col: 12,
				wcagAriaLabel: t('forms:WCAG-Label_DropDownPurpose'),
			},
		],
	}
}